import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import isFunction from 'lodash/isFunction';

import rootReducer from '../reducers';

export const history = createBrowserHistory();

export default function configureStore(initialState) {
  const enhancers = [];

  const middleware = [thunk, routerMiddleware(history)];

  // createLogger() itself (not just pushing it to middleware) must stay inside this dev-only
  // check - it was previously called unconditionally at module scope, which meant webpack
  // couldn't tree-shake the redux-logger import out of the production bundle even though it
  // was never actually used there (~10KB of dead weight shipped to every real visitor).
  if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.devToolsExtension;

    if (isFunction(devToolsExtension)) {
      enhancers.push(devToolsExtension());
    }

    const logger = createLogger({
      predicate: (getState, action) => action.type !== '@@router/LOCATION_CHANGE'
    });
    middleware.push(logger);
  }

  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  );

  const store = createStore(rootReducer, initialState, composedEnhancers);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
